module.exports = __webpack_public_path__ + "static/media/logo.239b5661.png";